module.exports = __webpack_public_path__ + "static/img/20221224_01.19609e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221224_01.png
// module id = HTNz
// module chunks = 0